import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppSidebarForm } from './app-sidebar-form.component';

@NgModule({
  declarations: [
    AppSidebarForm
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    AppSidebarForm
  ]
})
export class AppSidebarFormModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-sidebar/app-sidebar-form/app-sidebar-form.module.ts